import React from 'react';
import axios from 'axios';
import HorseMediaUpload from '../media/MediaUploader';
import MediaGallery from '../media/MediaGallery';

const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;

async function uploadFile(file, type = 'image') {
  const formData = new FormData();
  formData.append('file', file);

  const endpoint = `/api/upload/${type}`;

  try {
    const res = await axios.post(endpoint, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return res.data.url;
  } catch (err) {
    console.error('Upload error:', err);
    throw err;
  }
}

export default function Step4Pricing({ formData, onNext, onBack, onChange }) {
  const handleInput = (e) => {
    const { name, value, type, checked } = e.target;
    const finalValue = type === 'checkbox' ? checked : value;

    onChange({
      saleInfo: {
        ...formData.saleInfo,
        [name]: finalValue,
      },
    });
  };

  const handleMediaUpload = (mediaItem) => {
    onChange({
      media: [...(formData.media || []), mediaItem],
    });
  };

  const handleMediaRemove = (type, index) => {
    if (type === 'media') {
      const updated = [...formData.media];
      updated.splice(index, 1);
      onChange({ media: updated });
    }
  };

  const auctionEnd =
    formData.saleInfo?.auctionStart && formData.saleInfo?.auctionDuration
      ? new Date(
          new Date(formData.saleInfo.auctionStart).getTime() +
            formData.saleInfo.auctionDuration * 24 * 60 * 60 * 1000
        ).toLocaleString(undefined, {
          dateStyle: 'medium',
          timeStyle: 'short',
        })
      : null;

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold mb-4">Sale Type & Media</h2>

      {/* Sale Type */}
      <div>
        <label className="block text-sm font-bold mb-1">Sale Type</label>
        <select
          name="saleType"
          value={formData.saleInfo?.saleType || ''}
          onChange={handleInput}
          className="w-full border rounded px-3 py-2"
        >
          <option value="">Select</option>
          <option value="Buy Now">Buy Now</option>
          <option value="Auction">Auction</option>
          <option value="Hybrid">Auction + Buy Now</option>
        </select>
      </div>

      {(formData.saleInfo?.saleType === 'Buy Now' || formData.saleInfo?.saleType === 'Hybrid') && (
        <div>
          <label className="block text-sm font-bold mb-1">Buy Now Price ($)</label>
          <input
            type="text"
            name="buyNowPrice"
            value={formData.saleInfo?.buyNowPrice || ''}
            onChange={handleInput}
            className="w-full border rounded px-3 py-2"
          />
        </div>
      )}

      {(formData.saleInfo?.saleType === 'Auction' || formData.saleInfo?.saleType === 'Hybrid') && (
        <div>
          <label className="block text-sm font-bold mb-1">Starting Bid Price ($)</label>
          <input
            type="text"
            name="auctionStartingPrice"
            value={formData.saleInfo?.auctionStartingPrice || ''}
            onChange={handleInput}
            className="w-full border rounded px-3 py-2"
          />

          <label className="block text-sm font-bold mb-1 mt-4">Auction Duration (days)</label>
          <select
            name="auctionDuration"
            value={formData.saleInfo?.auctionDuration || ''}
            onChange={handleInput}
            className="w-full border rounded px-3 py-2"
          >
            <option value="">Select duration</option>
            {[3, 7, 14, 24, 30].map((d) => (
              <option key={d} value={d}>{d} days</option>
            ))}
          </select>

          <label className="block text-sm font-bold mb-1 mt-4">Start Date & Time</label>
          <input
            type="datetime-local"
            name="auctionStart"
            value={formData.saleInfo?.auctionStart || ''}
            onChange={handleInput}
            className="w-full border rounded px-3 py-2"
          />

          {auctionEnd && (
            <p className="text-sm text-gray-600 mt-2">
              Auction will end on: {auctionEnd}
            </p>
          )}
        </div>
      )}

      {/* Sponsored Listing */}
      <div>
        <label className="inline-flex items-center mt-4">
          <input
            type="checkbox"
            name="isSponsored"
            checked={formData.saleInfo?.isSponsored  || false}
            onChange={handleInput}
            className="form-checkbox h-5 w-5 text-primary"
          />
          <span className="ml-2 text-sm">
            Promote this horse to buyers within 100 miles (Sponsored Listing)
          </span>
        </label>
      </div>

      {/* Media Upload */}
      <HorseMediaUpload
        onUploadComplete={(mediaObj) => {
          if (!mediaObj.url || !mediaObj.public_id) {
            console.warn('⚠️ Skipping invalid media object:', mediaObj);
            return;
          }
          const updated = [...(formData.media || []), mediaObj];
          onChange({ media: updated });
        }}
      />

      {formData.media?.length > 0 && (
        <MediaGallery
          media={formData.media}
          onRemove={(type, index) => {
            const updated = [...formData.media];
            updated.splice(index, 1);
            onChange({ media: updated });
          }}
          onChange={(updated) => onChange({ media: updated })}
        />
      )}

      {/* Navigation */}
      <div className="flex justify-between mt-8">
        <button onClick={onBack} className="bg-gray-300 text-black py-2 px-6 rounded">Back</button>
        <button onClick={onNext} className="bg-primary text-white py-2 px-6 rounded hover:bg-primary-dark">Next</button>
      </div>
    </div>
  );
}
